import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { formatReadSettingsAdapts, FormatReadSettingsAdapter } from './format-read-settings.adapter';
import {
    convertCompressionSettingsToResource,
    convertCompressionSettingsToModel
} from '../compression-read-settings/compression-read-settings.util';
import { ParquetFormatReadSettings } from 'app/model/pipeline/copysource/format-read-settings/parquet-format-read-settings';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ParquetFormatReadSettings),
    asynchronous: true,
    adapts: {
        ...formatReadSettingsAdapts
    }
})
export class ParquetFormatReadSettingsAdapter extends FormatReadSettingsAdapter<
    ParquetFormatReadSettings,
    Model.FormatReadSettings
> {
    protected override async _toResource(model: ParquetFormatReadSettings): Promise<Model.FormatReadSettings> {
        const result: Model.FormatReadSettings = FormatReadSettingsAdapter.getCommonReadSettingsProperties(
            Metamodel.modelFor(ParquetFormatReadSettings).name
        );
        await convertCompressionSettingsToResource(model.compressionProperties, result, this.context);
        return result;
    }

    protected override async _toModel(
        resource: Model.FormatReadSettings,
        copySource: CopySource
    ): Promise<ParquetFormatReadSettings> {
        const result = FormatReadSettingsAdapter.createReadSettingsWithCommonProperties(
            ParquetFormatReadSettings.MODEL,
            copySource
        ) as ParquetFormatReadSettings;
        await convertCompressionSettingsToModel(resource.compressionProperties, result, this.context);
        return result;
    }
}
